import React, { useContext } from 'react';

import './About.css';
import { ThemeContext } from '../../contexts/ThemeContext';
import { aboutData } from '../../data/aboutData';

function About() {
    const { theme } = useContext(ThemeContext);

    return (
        <div className='about' id='about' style={{ backgroundColor: theme.secondary }}>
            <div className='about-shell'>
                <div className='about-card'>
                    <div className='about-description'>
                        <p className='section-kicker'>About</p>
                        <h2 style={{ color: theme.primary }}>{aboutData.title}</h2>
                        <p style={{ color: theme.tertiary80 }}>{aboutData.description1}</p>
                        <p style={{ color: theme.tertiary80 }}>{aboutData.description2}</p>
                        <div className='about-highlights'>
                            {aboutData.highlights?.map((item) => (
                                <span key={item}>{item}</span>
                            ))}
                        </div>
                    </div>
                    <div className='about-visual'>
                        <div className='about-img'>
                            <img src={aboutData.image === 1 ? theme.aboutimg1 : theme.aboutimg2} alt='About' />
                        </div>
                        <div className='about-stat-card' style={{ background: theme.primary30, color: theme.tertiary }}>
                            <strong>Experience</strong>
                            <span>9+ years building reliable systems, modern APIs, and scalable product experiences.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About
